import { render, staticRenderFns } from "./yesTabs.vue?vue&type=template&id=6ea0f4d5"
import script from "./yesTabs.vue?vue&type=script&lang=js"
export * from "./yesTabs.vue?vue&type=script&lang=js"
import style0 from "./yesTabs.vue?vue&type=style&index=0&id=6ea0f4d5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports